import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { BorrowersStore } from '../stores';

export const useBorrowersStore = () => useContext<{
  borrowersStore: BorrowersStore
}>(StoreContext);
